<div class="bulk-bar" *ngIf="count() > 0">
  <span class="bulk-bar-count">{{
    'shell.table.selected' | translate: { count: count() }
  }}</span>

  <div class="bulk-bar-divider"></div>

  <div class="bulk-bar-actions">
    <button
      type="button"
      class="bulk-bar-action"
      *ngFor="let action of visibleActions(); trackBy: trackByLabel"
      [class.bulk-bar-action-danger]="action.danger"
      [disabled]="isDisabled(action)"
      (click)="run(action)"
    >
      <i *ngIf="action.icon" [class]="action.icon"></i>
      <span>{{ label(action) }}</span>
    </button>
  </div>

  <button type="button" class="bulk-bar-clear" (click)="onClear()">
    {{ 'shell.table.clearSelection' | translate }}
  </button>
</div>
